export const summaryKeys = {
    list: () => ['summary', 'list'],
    content: (id) => ['summary', id, 'content'],
    state: (id) => ['summary', id, 'state'],
    prompt: (id) => ['summary', id, 'prompt']
};
//# sourceMappingURL=summary.keys.js.map